import axios from "axios";

export const getGraficiKpiApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/grafici/`);
};

export const getReportKpiApi = (listaKpi) => {
    // Dovrei chiamare una GET, ma avrei troppi dati da passare in qs. Posto così uso il payload
    let payload = listaKpi.filter(kpi => kpi.export == 1);
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/report/`, payload);
}